import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import React from 'react'
import { WizTableForm } from '../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
import LookUpInfo from './lookUpInfo'


//配置项
let componentName = 'requirementRecord'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {width: 120}
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {width: 100}
  },
  {
    title: "手机号",
    name: "mobile",
    dataIndex: "mobile",
    tableItem: {width: 120}
  },
  {
    title: "组织名称",
    name: "orgName",
    tableItem: {
      width: 200
    },
  },
  {
    title: "组织编码",
    name: "orgCode",
    tableItem: {
      width: 150
    },
  },
  {
    title: "开店状态",
    name: "state",
    tableItem: {
      width: 100
    },
    dict: [
      { code: 0, codeName: "已关店" },
      { code: 1, codeName: "已开店" },
      { code: 2, codeName: "建设中" }
    ],
  },
  {
    title: "组织",
    name: "orgId",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...organizationConfig
    }
  },
  {
    title: "岗位",
    name: "positionId",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...positionConfig,
    }
  },
  {
    title: "岗位",
    name: "positionName",
    tableItem: {width: 100},
  },
  {
    title: "任职状态",
    name: "jobState",
    dataIndex: "jobState",
    tableItem: {width: 80},
    dict: [
      { code: 1, codeName: "在职" },
      { code: 0, codeName: "离职" }
    ],
  },
  {
    title: "培训情况",
    name: "trainingSituation",
    dataIndex: "trainingSituation",
    dict: [
      { code: 0, codeName: "完成" },
      { code: 1, codeName: "未完成" }
    ],
    tableItem: {},
    searchItem: {
      type: "select"
    },
  },
  
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        collapse: false,
        buttonSort: [],
        buttons: [
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      // showAuth: {
      //   title: '适用范围',
      //   dataIndex: 'authData'
      // },
      rowOperateSort: ['viewTrainingRequirements'],
      rowOperateView: [
        {
          key: "viewTrainingRequirements",
          custom: true,
          params: { children: "查看培训要求"},
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "查看培训要求",
                diy: (e) => {
                  return (
                    <LookUpInfo
                      key={'requirements' + e.record.id}
                      {...e}
                    />
                  )
                },
                footer:null,
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          }
        },
      ],
      commonOperate: {
        add: true,
        update: true
      }
    }
  }
};

const apis = (data)=>{
  const {id} = data;
  return  {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10 ,requirementId:id}
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  const {id} = args;
  return {
    apis: apis({id}),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
